<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div>
            <div>
              <div class="card top-draft">
                <div class="col-lg-12 list-header pad-header-bg clearfix">
                  <div class="header-item-fix">
                    <b-form-input
                      size="sm"
                      type="text"
                      v-model="pageParams.contentKeyword"
                      placeholder="请输入搜索内容"
                      @keyup.enter.native="search"
                    ></b-form-input>
                    <b-button size="sm" variant="primary" @click="search()">
                      <i
                        class="bx bx-search-alt-2 font-size-16 align-middle"
                      ></i>
                      搜索
                    </b-button>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="resetParams()"
                    >
                      <i class="bx bx-revision font-size-16 align-middle"></i>
                      重置
                    </b-button>
                  </div>
                  <el-button
                    size="mini"
                    @click="selectComment()"
                    type="primary"
                    icon="el-icon-plus"
                    v-if="power['添加']"
                    >添加</el-button
                  >
                  <el-button
                    v-if="power['添加']"
                    size="mini"
                    @click="createNewReply"
                    type="primary"
                    >新建回复</el-button
                  >
                </div>

                <div class="col-lg-12">
                  <div class="table-responsive" v-loading="tableLoading">
                    <table
                      class="table table-nowrap table-centered align-middle table-hover"
                    >
                      <thead>
                        <tr>
                          <th scope="col" style="width: 70px">
                            <b-form-checkbox
                              @change="checkedAll"
                              v-model="indeterminate"
                              checked
                              plain
                            ></b-form-checkbox>
                          </th>
                          <th scope="col" style="width: 70px">ID</th>
                          <th scope="col">标题</th>
                          <th scope="col">作者</th>
                          <th scope="col">审核状态</th>
                          <th scope="col">点赞</th>
                          <th scope="col">日期</th>
                          <th scope="col">热评</th>
                          <th scope="col">操作</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td>
                            <b-form-checkbox
                              v-model="choiceListIds"
                              :value="item.id"
                              checked
                              plain
                            ></b-form-checkbox>
                          </td>
                          <td>{{ item.id }}</td>
                          <td class="w-200 white-inherit">
                            {{ item.message }}
                            <t-icon
                              color="#556ee6"
                              name="attach"
                              v-if="item.attachmentDtoList.length"
                            />
                          </td>
                          <td>{{ item.userName || "--" }}</td>
                          <td>
                            <span v-if="item.verifyState === 0">草稿</span>
                            <span v-if="item.verifyState === 2">驳回</span>
                            <span v-if="item.verifyState === 1">通过</span>
                            <span v-if="item.verifyState === 3">待审核</span>
                          </td>
                          <td>{{ item.likeNum || "0" }}</td>
                          <td>{{ item.updatedAt || "--" }}</td>
                          <td>
                            <span v-if="item.hotState == 0">否</span>
                            <span v-if="item.hotState == 1">是</span>
                          </td>

                          <td>
                            <ul
                              class="list-inline font-size-20 contact-links mb-0"
                            >
                              <li
                                class="list-inline-item px-2"
                                @click="toDetail(item)"
                                v-if="power['编辑']"
                              >
                                <a v-b-tooltip.hover title="编辑">
                                  <i class="bx bxs-edit"></i>
                                </a>
                              </li>
                              <li
                                class="list-inline-item px-2"
                                @click="toStorage(item)"
                                v-if="power['入库']"
                              >
                                <a v-b-tooltip.hover title="入库">
                                  <i class="bx bx-paste"></i>
                                </a>
                              </li>
                              <li
                                v-if="power['移除']"
                                class="list-inline-item px-2"
                                @click="remove(item)"
                              >
                                <a v-b-tooltip.hover title="移除">
                                  <i class="bx bx-trash"></i>
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="!items || !items[0]" class="xb-table-noData">
                      <span v-if="!tableLoading && !items[0]">暂无数据</span>
                    </div>
                  </div>
                  <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
                  batchs 批量操作的列表
                  pageCallback 分页组件的回调方法 -->
                  <!-- <pagination
                    class="bath_r_20"
                    :isBatch="true"
                    :batchs="batchs"
                    ref="page"
                    @pageCallback="pageCallback"
                  ></pagination> -->
                  <pagination
                    class="bath_r_20"
                    :isBatch="true"
                    :batchs="batchs"
                    :total="pageTotal"
                    :pageSize="pageParams.pageSize"
                    :page.sync="pageParams.page"
                    :pageSizes="[30, 50, 100]"
                    @pageCallback="pageCallback"
                    ref="page"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <detail @pageCallback="pageCallback" ref="detail"></detail>
      <putStorage @pageCallback="pageCallback" ref="storage"></putStorage>
      <comment-dialog
        @pageCallback="pageCallback"
        ref="comment"
      ></comment-dialog>
      <el-dialog
        :visible.sync="addReplyModal"
        title="回复"
        width="410px"
        class="topic-reply-modal"
      >
        <div style="width: 100%; display: flex">
          <span style="width: 70px">回复内容：</span>
          <el-input
            style="width: 300px"
            type="textarea"
            :autosize="{ minRows: 5 }"
            v-model="newReply"
          ></el-input>
        </div>
        <div slot="footer">
          <button
            class="btn btn-sm btn-outline-dark"
            type="button"
            style="margin-right: 10px"
            @click="closeReplyModal"
          >
            取消
          </button>
          <button
            class="btn btn-sm btn-primary"
            type="button"
            @click="saveReply"
          >
            确定
          </button>
        </div>
      </el-dialog>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Vue from "vue";
import Swal from "sweetalert2";
import content from "@/server/api/comments";
import detail from "./detail";
import putStorage from "./putStorage";
import commentDialog from "../commentDialog.vue";
import { addComment as addCommentApi } from "@/server/api/topic.js";
import { changeList } from "@/util/fun.js";
/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
    detail,
    putStorage,
    commentDialog,
  },

  data() {
    return {
      newReply: "",
      addReplyModal: false,
      choiceListIds: [], //当前所选择的id
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        contentKeyword: "",
        id: "",
      },
      index_id: "",
      items: [],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "删除", value: "1" },
        { text: "入库", value: "2" },
      ],
      pageTotal: 0,
      topicId: "", //话题ID
      userId: "", //题主ID
      power: [],
      tableLoading: false,
    };
  },

  watch: {
    choiceListIds: function () {
      if (
        this.choiceListIds.length == this.items.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    this.power = this.utils.currentPower("话题-回复");
    this.batchs = [];
    if (this.power["移除"] || this.power["入库"]) {
      this.batchs.push({ text: "批量操作", value: "0" });
      if (this.power["移除"]) {
        this.batchs.push({ text: "删除", value: "1" });
      }
      if (this.power["入库"]) {
        this.batchs.push({
          text: "入库",
          value: "2",
        });
      }
    }
    if (this.$route.query.commentId) {
      this.index_id = this.$route.query.commentId;
      this.getList();
    }
    this.topicId = this.$route.query.topicId;
    this.userId = this.$route.query.userId;
  },

  created() {},

  methods: {
    closeReplyModal() {
      this.addReplyModal = false;
    },
    saveReply() {
      this.addComment(2);
    },
    createNewReply() {
      this.newReply = "";
      this.addReplyModal = true;
    },
    selectComment() {
      this.$refs.comment.showModel();
    },
    //获取列表数据
    getList(showLoading) {
      if (showLoading !== false) {
        this.tableLoading = true;
        this.items = [];
      }
      let params = this.utils.getQuery(this.pageParams);
      params.id = this.index_id;
      this.choiceListIds = [];
      content.replys(params).then((resp) => {
        console.log("回复列表", resp);
        if (resp.code == 0 && resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = resp.data.items;
            this.pageTotal = resp.data.total;
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "comments") {
        // this.getList();
        let item = obj.item;
        if (item) {
          this.items = this.items.map((tr) => {
            if (tr.id == item.id) {
              return { ...tr, ...item };
            } else return tr;
          });
        }
      }
      if (obj.code === "comment") {
        this.addComment(1, obj.item);
        //let itemList = obj.item;
        //this.currentComments = this.utils.fn2(itemList);
      }
      if (obj.code === "storage") {
        // this.getList();
        this.choiceListIds = [];
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.$refs.storage.showModel(this.choiceListIds, "isBatch");
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
      }
    },
    addComment(type, items) {
      // type为1添加运营评论，type为2添加题主回复
      let params = {
        id: this.topicId,
        comments: [],
      };
      if (type === 2) {
        let obj = {};
        obj = {
          message: this.newReply,
          parentId: this.index_id,
          messageType: 1, //1为题主回复，2为灌水评论
        };
        if (this.userId) {
          obj.userId = this.userId;
        }
        params.comments.push(obj);
      } else {
        if (items.length == 0) {
          this.warning("未选择数据");
          return;
        }
        if (items.length > 0) {
          console.log("items", items);
          items.forEach((item) => {
            let obj = {
              id: this.topicId,
              messageType: 2, //2为灌水评论
            };
            obj.parentId = this.index_id;
            obj.message = item.message;
            obj.video = item.video || "";
            obj.image = item.image || "";
            params.comments.push(obj);
          });
        }
      }
      console.log("保存参数", params);
      addCommentApi(params).then((res) => {
        if (res.code === 0) {
          this.success("添加成功");
          this.getList(false);
          this.addReplyModal = false;
        } else {
          this.warning(res.msg);
        }
      });
    },
    //去编辑
    toDetail(item) {
      this.$refs.detail.showModel(item);
    },

    toStorage(item) {
      this.$refs.storage.showModel(item);
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.items.map((item) => item.id);
      } else {
        this.choiceListIds = [];
      }
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          content.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
              if (this.items.length == params.ids.length) {
                this.getList();
              } else {
                this.pageTotal -= params.ids.length;
                this.items = changeList("delete", this.items, params.ids, "id");
              }
              if (!item) {
                this.choiceListIds = [];
              }
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.topic-reply-modal ::v-deep .el-dialog__body {
  padding: 10px 20px;
}
</style>
